import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, DialogTitle as MuiDialogTitle, Typography } from "@mui/material";
import React from "react";
import { AssistedIconBadgeVariant, assistedIconBadgeSx } from "../assistedIconBadgeSx";

interface RecipeGptDialogHeaderProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  onClose: () => void;
  /** Soft info wash for link/photo; indigo→sky for Generate with AI. */
  badgeVariant?: AssistedIconBadgeVariant;
}

export const RecipeGptDialogHeader = ({ title, subtitle, icon, onClose, badgeVariant = "softInfo" }: RecipeGptDialogHeaderProps) => (
  <MuiDialogTitle
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: 1,
      borderBottom: "1px solid",
      borderColor: "greyscale.200",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, minWidth: 0, flex: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          flexShrink: 0,
          borderRadius: 1,
          ...assistedIconBadgeSx(badgeVariant),
        }}
        aria-hidden
      >
        {icon}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25, minWidth: 0, pt: 0.25 }}>
        <Typography variant="h4" component="span">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </Box>
    <IconButton onClick={onClose} size="small" aria-label="Close" sx={{ mt: -0.25, mr: -0.5 }}>
      <CloseIcon />
    </IconButton>
  </MuiDialogTitle>
);
